﻿import Vue from "vue";
import DonneesReferentiellesVue_ from "../vue/DonneesReferentiellesVue";
import common from "../../common";
import utilities_ from "../utilities";
import context_ from "../context";
import SearchBox_ from "../../core/SearchBox";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";

const utilities = require("../utilities") as typeof utilities_;
const context = require("../context") as typeof context_;
// const SearchBox = require("../../core/SearchBox") as SearchBox_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const DonneesReferentiellesVue = require("../vue/DonneesReferentiellesVue") as DonneesReferentiellesVue_;

interface ISettings {
    enableSearchBox: boolean;
    searchBoxSettings: common.ISearchBoxSettings;
    dropdownUrl: string;
    dropdownSelectedItem: string;
}

class DonneesReferentielles implements common.IWebComponent {
    private _isInit = false;
    private _vueElId?: string;
    private _vue?: DonneesReferentiellesVue_;
    private _searchBox?: SearchBox_ | null;
    private _dropdownSelectedItem?: string;
    private _dropdownUrl?: string;
    //private _loader: Core.Loader;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        this._dropdownSelectedItem = s.dropdownSelectedItem || "";
        this._dropdownUrl = s.dropdownUrl;
        this._vueElId = "DonneesReferentiellesSummaryVue";

        this.setupVue(s);

        //this._loader = new Core.Loader(this._vueElId);

        this._searchBox = s.enableSearchBox
            ? new SearchBox_(s.searchBoxSettings)
            : null;

        return context.components.add(this);
    }

    private setupVue(settings: any) {
        // Définition de Vue pour la partie Summary
        // NB: Les params sont passés ainsi car 'vue-class-component' ne permet pas de les passer par le ctor
        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            editModeOn: true
        };

        this._vue = new DonneesReferentiellesVue_();
        this._vue?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        });
    }

    private onFormAction(action: HotEditableFormAction_) {
        if (!action.isFieldChanged)
            return;

        if (action.getFieldType() === common.HotEditableFieldTypes.select) {
            const id = action.getId();
            if (id === "RefStandardEntity") {
                const value = action.getFieldTextualValue();
                if (value)
                    if (value !== this._dropdownSelectedItem) {
                        const url = this._dropdownUrl?.replace("__name__", value);
                        utilities.redirect(url);
                        return;
                    }
            }
        }
    }
}

export = DonneesReferentielles;
